// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1484":"css/admin-app.7059","3443":"css/app.7059"}[chunkId] + ".css";
};